import React, { createContext, useContext, useState, useCallback } from 'react';

interface ActiveGeneration {
  proposalId: number;
  proposalTitle: string;
}

interface GenerationContextValue {
  activeGeneration: ActiveGeneration | null;
  startGeneration: (proposalId: number, proposalTitle: string) => void;
  endGeneration: () => void;
}

const GenerationContext = createContext<GenerationContextValue | null>(null);

export const GenerationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeGeneration, setActiveGeneration] = useState<ActiveGeneration | null>(null);

  const startGeneration = useCallback((proposalId: number, proposalTitle: string) => {
    setActiveGeneration({ proposalId, proposalTitle });
  }, []);

  const endGeneration = useCallback(() => {
    setActiveGeneration(null);
  }, []);

  return (
    <GenerationContext.Provider value={{ activeGeneration, startGeneration, endGeneration }}>
      {children}
    </GenerationContext.Provider>
  );
};

export const useGeneration = (): GenerationContextValue => {
  const ctx = useContext(GenerationContext);
  if (!ctx) throw new Error('useGeneration deve ser usado dentro de GenerationProvider');
  return ctx;
};
